export const DISPLAY_SETTING_KEY = {
  TABLE_NEST_SETTING: 'table-nest-setting',
  TABLE_COLUMNS_SETTING: 'table-columns-setting',
  PROJECT_LEDGER_VIEW_SETTING: 'project-ledger-view-setting',
};

export const FEATURE_TYPE_KEY = {
  GROUP: 'group',
  LIST: 'list',
};

export const getStorageSettingKey = (
  state: string,
  feature: string,
  param: string,
) => {
  return `${state}.${feature}.${param}`;
};
